//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vInput from '~/mixins/vInput.js'

export default {
  name: 'VInputTag',
  mixins: [vInput],
  props: {
    ...vInput.props,
    showEye: {
      type: Boolean,
      default: true
    },
    clearValueIfIdRequired: {
      type: Boolean,
      default: false
    },
    minNumber: {
      type: Number,
      default: 1
    },
    focusAfterClear: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ...vInput.data(),
      badgeId: 0,
      tags: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value.split(',')
      },
      set () {
        this.$emit('input', this.tags.join(','))
      }
    }
  },

  mounted () {
    this.$super(vInput).getRandomInt()
    this.tags = this.value.split(',')
    this.$nextTick(() => {
      this.input.curType = this.$refs?.input?.getAttribute('type')
    })
  },
  methods: {
    fixMobile () {
      this.model = this?.$refs?.input?.value
    },
    setFocus () {
      this.$super(vInput).setFocus()
    },
    addTag (event) {
      event.preventDefault()
      const val = event.target.value.trim()
      if (val.length > 0) {
        if (this.tags.length >= 1) {
          for (let i = 0; i < this.tags.length; i++) {
            if (this.tags[i] === val) {
              return false
            }
          }
        }
        this.tags.push(val)
        this.model = this.tags
        event.target.value = ''
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
    },
    removeLastTag (event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
      }
    }
  }
}
